import { render, staticRenderFns } from "./PostFavoritesTable.vue?vue&type=template&id=1e8d29b5&scoped=true"
import script from "./PostFavoritesTable.vue?vue&type=script&lang=js"
export * from "./PostFavoritesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8d29b5",
  null
  
)

export default component.exports